import React, { useState, useEffect, useMemo,useCallback } from "react";
import { ToastContainer } from "react-toastify";

import { Button, Modal } from "react-bootstrap";
import PageTitle from "../../layouts/PageTitle";
import Table from "../../components/table/ReactTable/Table";

import { ColumnFilter } from "../../components/table/ReactTable/ColumnFilter";
import { Badge } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";

import useFullPageLoader from "../../../hooks/useFullPageLoader";
import { inventoryHistoryActions } from "../../../_store";
import productExpirationPDF from "../../components/export/productExpirationPDF";
import generateXlsx from "../../components/export/generateXlsx";

const ProductExpirationReport = () => {
  const dispatch = useDispatch();

  const [loader, showLoader, hideLoader] = useFullPageLoader();

  // #region ------------------  Reducer --------------------------------

 
  const productExpirationList = useSelector(
    (x) => x.inventoryHistory.productExpirationList
  );
  

  // #endregion ------------------  Reducer End --------------------------------
  const [finalTableData, setFinalTableData] = useState([]);
    const handleTableDataUpdate = useCallback((data) => {
        setFinalTableData(data);
      }, []);
  const PRODUCTS_COLUMNS = [
    {
      Header: "Category",
      Footer: "Category",
      accessor: "CategoryName",
      justify: "center",
      Filter: ColumnFilter,
    },
    {
      Header: "Product Name",
      Footer: "Product Name",
      accessor: "ProductName",
      justify: "center",
      Filter: ColumnFilter,
    },

    {
      Header: "SKU",
      Footer: "SKU",
      accessor: "SKU",
      justify: "center",
      Filter: ColumnFilter,
    },
    {
      Header: "Purchase Quantity",
      Footer: "Purchase Quantity",
      accessor: "TransactionUnits",
      justify: "center",
      Filter: ColumnFilter,
    },
    {
      Header: "Remaining Quantity",
      Footer: "Remaining Quantity",
      accessor: "LotRemainingQuantity",
      justify: "center",
      Filter: ColumnFilter,
    },

    {
      Header: "Lot Number",
      Footer: "Lot Number",
      accessor: "LotNumber",
      justify: "center",
      Filter: ColumnFilter,
    },
    {
      Header: "Lot Date",
      Footer: "Lot Date",
      accessor: "LotDateString",
      justify: "center",
      Filter: ColumnFilter,
      fieldType: "Date",
    },
    {
      Header: "Expiring Date",
      Footer: "Expiring Date",
      accessor: "ExpiredDateString",
      justify: "center",
      Filter: ColumnFilter,
      fieldType: "Date",
    },
    {
      Header: "Days Remaining",
      Footer: "Days Remaining",
      accessor: "ExpiringDays",
      justify: "center",
      Filter: ColumnFilter,
      Cell: ({ row }) => {
        return (
          <>
            <div>
            <Badge 
            variant={`${row.original.WarrantyExpiryStatus ==="1" ? "outline-danger" : 
            (row.original.WarrantyExpiryStatus ==="2" ?"outline-warning":
            (row.original.WarrantyExpiryStatus ==="3" ?"outline-primary":
            (row.original.WarrantyExpiryStatus ==="4" ?"outline-info":"outline-light" ) ) )} badge-rounded`} >
            {row.original.ExpiringDays}
            </Badge>
               
             
            </div>
          </>
        );
      },
    }
    
  ];
  const generateColumns = [
    {
      header: "Category",
      dataKey: "CategoryName",
    },
    {
      header: "Product Name",
      dataKey: "ProductName",
    },
    {
      header: "SKU",
      dataKey: "SKU",
    },
    {
      header: "Purchase Quantity",
      dataKey: "TransactionUnits",
    },
    {
      header: "Remaining Quantity",
      dataKey: "LotRemainingQuantity",
    },
    {
      header: "Lot Number",
      dataKey: "LotNumber",
    },
    {
      header: "Lot Date",
      dataKey: "LotDateString",
    },
    {
      header: "Expiring Date",
      dataKey: "ExpiredDateString",
    },
    {
      header: "Days Remaining",
      dataKey: "ExpiringDays",
    },
  ];


  const handleClickPDF =()=>{
    let title = "Product Expiration Reports";

    const columnStyles={
      CategoryName :{halign: "center", cellWidth:30},
      ProductName :{halign: "center", cellWidth:40},
      SKU :{halign: "center", cellWidth:40},
      TransactionUnits :{halign: "center", cellWidth:25},
      LotRemainingQuantity :{halign: "center", cellWidth:25},
      LotNumber :{halign: "center", cellWidth:30},
      LotDateString :{halign: "center", cellWidth:30},
      ExpiredDateString :{halign: "center", cellWidth:30},
      ExpiringDays :{halign: "center", cellWidth:30 },
    }
    productExpirationPDF(finalTableData, generateColumns, true, title, columnStyles)
  }

  const handleClickExcel = () =>{
    let title = "Product Expiration Reports";
    const generateExcelColumns = [
      "Category Name",
      "Product Name",
      "SKU",
      "Purchase Quantity",
      "Remaining Quantity",
      "Lot Number",
      "Lot Date",
      "Expiring Date",
      "Days Remaining"
    ];
    let new_productExpirationList = finalTableData && finalTableData.map( obj =>{
      return {
        CategoryName: obj.CategoryName,
        ProductName:obj.ProductName,
        SKU: obj.SKU,
        TransactionUnits: obj.TransactionUnits,
        LotRemainingQuantity:obj.LotRemainingQuantity,
        LotNumber: obj.LotNumber,
        LotDateString :obj.LotDateString,
        ExpiredDateString :obj.ExpiredDateString,
        ExpiringDays :obj.ExpiringDays,
      }
    });
    generateXlsx(new_productExpirationList, generateExcelColumns, title)
  }

  const columns = useMemo(() => PRODUCTS_COLUMNS, []);
  
  useEffect(() => {
    dispatch(inventoryHistoryActions.getProductExpirationReport());

  }, [dispatch]);
  

  return (
    <>
      <PageTitle activeMenu="Product Expiration" motherMenu="Products" />
      <ToastContainer />
      <div className="card">
        <div className="card-header">
          <h4 className="card-title header-title">Product Expiration Report</h4>
          <div className="float-sm-end">
            <Button
              className="me-2"
              variant="danger btn-rounded"
              onClick={handleClickPDF}
            >
              <span className="btn-icon-start text-danger">
                <i className="fa fa-solid fa-file-pdf"></i>
                {/* <i className="fa fa-regular fa-file-excel"></i> */}
              </span>
              PDF
            </Button>
            <Button
              className="me-2"
              variant="secondary btn-rounded"
              onClick={handleClickExcel}
            >
              <span className="btn-icon-start text-secondary">
                {/* <i className="fa fa-solid fa-file-pdf"></i> */}
                <i className="fa fa-regular fa-file-excel"></i>
              </span>
              Excel
            </Button>
          </div>
        </div>
        <div className="card-body">
          <div className="row">
            
          </div>
          <Table columns={columns} data={productExpirationList} onDataUpdate={handleTableDataUpdate} />
        </div>
      </div>

      {loader}
    </>
  );
};

export default ProductExpirationReport;
